(function(){
  function euro(cents){ return (cents/100).toLocaleString('it-IT',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' €'; }
  function imgUrl(u){ if (!u) return ''; return u.indexOf('//') === 0 ? 'https:' + u : u; }
  function render(slot, p){
    var handle = slot.getAttribute('data-product');
    var imgs = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean);
    var imgA = imgUrl(imgs[0]);
    var imgB = imgUrl(imgs[1] || imgs[0]);
    var eyebrow = slot.getAttribute('data-eyebrow') || 'Hai letto fin qui. Porta a casa un pezzo.';
    slot.innerHTML =
      '<aside class="nemico-merce" aria-label="Rubrica Merce - contenuto commerciale">' +
        '<div class="nemico-merce__bar"><span class="tag">✶ Rubrica: Merce</span><span class="note">Contenuto commerciale &middot; siamo noi che vendiamo</span></div>' +
        '<div class="nemico-merce__grid">' +
          '<div class="nemico-merce__media">' +
            (imgA ? '<img class="nemico-merce__img--a" src="' + imgA + '" alt="' + p.title + '" loading="lazy">' : '') +
            (imgB ? '<img class="nemico-merce__img--b" src="' + imgB + '" alt="' + p.title + '" loading="lazy">' : '') +
          '</div>' +
          '<a class="nemico-merce__body" href="/products/' + handle + '">' +
            '<div class="nemico-merce__eyebrow">' + eyebrow + '</div>' +
            '<h2 class="nemico-merce__title">' + p.title + '</h2>' +
            '<p class="nemico-merce__text">' + (p.description || '').replace(/<[^>]*>/g,'').slice(0,170) + '</p>' +
            '<div class="nemico-merce__row"><span class="nemico-merce__price">' + euro(p.price) + '</span><span class="nemico-merce__arrow">&rarr;</span></div>' +
          '</a>' +
        '</div>' +
      '</aside>';
  }
  function init(){
    var slots = document.querySelectorAll('.blog-post-content .nemico-merce-slot, .nemico-merce-slot');
    slots.forEach(function(slot){
      var handle = slot.getAttribute('data-product');
      if (!handle) return;
      fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if (p) render(slot, p);
      }).catch(function(){});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Proposte impaginato: citazioni in Malfunction -> classi per lunghezza + accenti (il font non ha le vocali accentate: a' e' i' o' u' alla maniera della macchina da scrivere) */
(function(){
  if (!document.documentElement.hasAttribute('data-nm-layout')) return;
  var map={'\u00e0':"a'",'\u00e8':"e'",'\u00e9':"e'",'\u00ec':"i'",'\u00f2':"o'",'\u00f9':"u'",'\u00c0':"A'",'\u00c8':"E'",'\u00c9':"E'",'\u00cc':"I'",'\u00d2':"O'",'\u00d9':"U'",'\u00ab':'\u201c','\u00bb':'\u201d'};
  var re=/[\u00e0\u00e8\u00e9\u00ec\u00f2\u00f9\u00c0\u00c8\u00c9\u00cc\u00d2\u00d9\u00ab\u00bb]/g;
  function fix(){
    document.querySelectorAll('.blog-post-content blockquote').forEach(function(b){
      var n=b.textContent.trim().length;
      if (n>600) b.classList.add('nm-q-xl'); else if (n>220) b.classList.add('nm-q-long');
      var w=document.createTreeWalker(b,NodeFilter.SHOW_TEXT), t;
      while ((t=w.nextNode())) {
        if (t.parentNode.closest && t.parentNode.closest('cite')) continue;
        t.nodeValue=t.nodeValue.replace(re,function(c){ return map[c]; });
      }
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
})();
/* Banner merce: rotella verticale = scorre la pagina, orizzontale = scorre il banner */
window.addEventListener('wheel',function(e){if(Math.abs(e.deltaY)>Math.abs(e.deltaX)&&e.target&&e.target.closest&&e.target.closest('.nm-merch'))e.stopPropagation()},{capture:true,passive:true});